import * as _ from "lodash-es";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    filterBookmarks: {},
  },
  mutations: {
    setFilterBookmarks(state, filterBookmarks) {
      state.filterBookmarks = _.keyBy(filterBookmarks, "id");
    },
    updateFilterBookmark(state, item) {
      state.filterBookmarks = { ...state.filterBookmarks, [item.id]: item };
    },
    deleteFilterBookmark(state, id) {
      Vue.delete(state.filterBookmarks, id);
    },
  },
  getters: {
    filterBookmarksList: (state) =>
      _.orderBy(Object.values(state.filterBookmarks), ["created_at"], ["asc"]),
  },
};
